import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-arrow-progress",
  "use": "app-icon-arrow-progress-usage",
  "viewBox": "0 0 151 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 151 18\" id=\"app-icon-arrow-progress\"><clipPath id=\"app-icon-arrow-progress_a\"><path d=\"M0 0h19v18H0z\" /></clipPath><g fill=\"#E6E6E6\" fill-rule=\"evenodd\"><path d=\"M0 6h140v6H0zM151 9l-11 8V1z\" /></g><g clip-path=\"url(#app-icon-arrow-progress_a)\" transform=\"translate(0 1)\" fill=\"none\" fill-rule=\"evenodd\"><g fill=\"#3DCCA6\"><path d=\"M0 5h140v6H0zM151 8l-11 8V0z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol